<template>
    <div>
        <el-card id="printMe"   style="font-size: 14px;">
            <div style="  border-color:#000;text-align: center; font-size: 25px;margin-top: 10px;">{{ qiyeName }}车辆检查单 </div>
            <div class="print-only" style="margin-top: 10px;">----------------------------------------------------------------------------------------------------</div>
            <!-- <div>   <img src="../../../assets/log/logo.png" style="height: 100px;text-align: right;"></div> -->
            <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">

                <el-form-item label="车辆外观编号" prop="waiguan_bianhao">
                    {{ addForm.bianhao }}
                </el-form-item>

                <el-form-item label="车辆牌照" prop="paizhao">{{ addForm.paizhao }} </el-form-item>
                <el-form-item label="车辆车型" prop="waiguan_memo">{{ addForm.chexing01 }}-{{ addForm.chexing02 }}-{{
                addForm.chexing03 }}-{{ addForm.chexing04 }}</el-form-item>
                <el-form-item label="车辆外观" prop="waiguan_memo">{{ addForm.waiguan_memo }} </el-form-item>
                <!-- <el-form-item label="图片浏览">
                    <div style="height: 100%;">
                        <picUpload @backPicUrl="backPicUrl" show_type="1" :picsUrl="addForm.pics" :key="datekey"
                            max_count="10">
                        </picUpload>
                    </div>
                </el-form-item> -->
                <h3>40检查项目</h3>

                <div class="select_class">
                    <div   style="width: 1800px;max-height: 340px;color:#fff;">&nbsp;</div>
                    <div v-for="(item) in jianchaTishiList" :key="item.uid" style="width: 1800px;max-height: 440px;">
                        <div style="flex: 1;" v-if="item.value === 1">
                            <span style="width: 250px;max-height: 150px;display: inline-block;">[{{ item.xuhao }}]{{
                item.name }}:</span>
                            <span style="width: 110px;max-height: 150px;display: inline-block; color: #333;font: bold;">
                                {{ item.value === 0 ? '正常' : '异常' }}</span>
                            <span
                                style="width: 700px;max-height: 250px; display: inline-block; color: #333;font: bold; line-height: 1.5;font-size: 20px;margin-top: 30px;">
                                {{ item.tishi }} </span>
                        </div>

                    </div>
                    <div style="background-color: #555; height: 1px;"></div>
                    <div>
                        <span
                            style="width: 700px;max-height: 150px; display: inline-block; color: #333;font: bold; line-height: 1.5;">
                            客户评价 </span>
                        <span style="width: 250px;max-height: 150px;display: inline-block;">客户确认</span>
                    </div>
                    <div class="print-only" style="margin-top: 50px;">
                        ----------------------------------------------------------------------------------------------------</div>
                    <div class="print-only">{{ qiyeName
                        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：{{ userPhone }}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打印日期：{{ nowDate }}&nbsp;&nbsp;{{
                nowTime }} </div>

                </div>

            </el-form>
        </el-card>
        <div style="text-align: center;" v-if="diaoyongType === 1">
            <el-button type="primary" @click="handleExport()" v-if="false">导出电子表格</el-button>
            <el-button type="primary" @click="printPage">打印</el-button>
            <el-button type="primary" @click="add">关闭窗口</el-button>
        </div>
    </div>
</template>

<script>
import printJS from 'print-js'
import exportExcel from '../config/exportExcel'
// import picUpload from '../pic_com.vue'
export default {

    components: {
        // picUpload: picUpload
    },
    props: ['cheliang_uid', 'diaoyongType', 'caozuoType', 'editUid'], // diaoyongType 1 正常的界面管理调用 2 开单调用 editUid 如果有值，说明是修改
    // caozuoType 1 修改 2 显示
    data() {
        return {
            picsUid: '',
            pic_upload_url: window.sessionStorage.getItem('http_api') + '/upload',
            datekey: Date.now(),
            jianchaTishiList: [],
            addForm: {

            },
            addFormRules: {
                // waiguan_memo: [
                //   { required: true, message: '请输入车辆外观', trigger: 'blur' },
                //   { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                // ]
            },
            pics: '',
            userPhone: '',
            qiyeName: '',
            nowDate: new Date().toLocaleDateString('zh-CN'),
            nowTime: new Date().toLocaleTimeString('zh-CN')

        }
    },
    created() {
        console.log(802, this.cheliang_uid)
        if (this.cheliang_uid === undefined) this.addForm.cheliang_uid = ''
        else this.addForm.cheliang_uid = this.cheliang_uid
        this.getJianchaTishiList() // 先读取所有标题信息，然后写入变量数据
        if (this.caozuoType === 1) this.getBianhao_waiguan_add() // 说明是添加
        if (this.caozuoType === 2) this.Info(this.editUid)
    },
    mounted() {
        this.userPhone = window.sessionStorage.getItem('qiye_mob')
        // this.copyright = window.sessionStorage.getItem('copyright')
        this.qiyeName = window.sessionStorage.getItem('qiye_name')
    },
    methods: {

        printPage() {
            // 创建一个新窗口
            const printWindow = window.open('', '_blank');
            if (printWindow) {
                // 设置页面HTML
                printWindow.document.write('<html><head><title>打印页面</title>');
                printWindow.document.write('<style> *{font-size: 18px}</style>');
                printWindow.document.write('</head><body>');
                const styleNode = printWindow.document.createElement('style')
                styleNode.innerHTML = `
                        @media print {
                            @page {
                                margin: 3mm;
                            }

                        }
                        #printMe {
                                    font-size: 18px;
                                }
                        `
                printWindow.document.head.appendChild(styleNode)
                printWindow.document.write(document.querySelector('#printMe').innerHTML);
                printWindow.document.write('</body></html>');
                printWindow.document.close(); // 关闭文档
                printWindow.focus(); // 聚焦新窗口
                // 打印内容
                printWindow.print();
                // 关闭新窗口
                printWindow.close();
            }
        },
        handleExport() {
            exportExcel('report', '导出.xlsx')
        },
        async getJianchaTishiList() {
            var queryInfo = {
                C_type: 'get_list',
                C_table_name: 'jiancha_tishi_list',
                query: '',
                pageNum: 1,
                pageSize: 100,
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            }
            const { data: res } = await this.$http.get('get_api', {
                params: queryInfo
            });
            this.jianchaTishiList = JSON.parse(res.data)[0].dataList;
            console.log(9902, this.jianchaTishiList)
        },
        backPicUrl(pics) {
            this.addForm.pics = pics
            this.pics = pics
        },
        quxiao() {
            if (this.diaoyongType === 1) this.$emit('getWaiguanclose', this.Info)
        },
        async getBianhao_waiguan_add() {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 15 }
            });
            // console.log(9999, JSON.parse(res.data)[0].bianhao_l)
            // console.log(JSON.parse(res.data)[0].bianhao_s);
            this.addForm.bianhao = JSON.parse(res.data)[0].bianhao_l;
        },
        async Info(uid) {
            await this.getJianchaTishiList()
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'waiguanShow_info', uid: uid, C_type: 'get_info' }
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            this.addForm = JSON.parse(res.data)[0].data[0]
            console.log(999, this.addForm)
            this.xianshi()
        },
        xianshi() {
            // 读取数据存入数据以供显示
            console.log(this.jianchaTishiList[0])
            this.jianchaTishiList[0].value = this.addForm.Jiance000
            this.jianchaTishiList[1].value = this.addForm.Jiance001
            this.jianchaTishiList[2].value = this.addForm.Jiance002
            this.jianchaTishiList[3].value = this.addForm.Jiance003
            this.jianchaTishiList[4].value = this.addForm.Jiance004
            this.jianchaTishiList[5].value = this.addForm.Jiance005
            this.jianchaTishiList[6].value = this.addForm.Jiance006
            this.jianchaTishiList[7].value = this.addForm.Jiance007
            this.jianchaTishiList[8].value = this.addForm.Jiance008
            this.jianchaTishiList[9].value = this.addForm.Jiance009
            this.jianchaTishiList[10].value = this.addForm.Jiance010
            this.jianchaTishiList[11].value = this.addForm.Jiance011
            this.jianchaTishiList[12].value = this.addForm.Jiance012
            this.jianchaTishiList[13].value = this.addForm.Jiance013
            this.jianchaTishiList[14].value = this.addForm.Jiance014
            this.jianchaTishiList[15].value = this.addForm.Jiance015
            this.jianchaTishiList[16].value = this.addForm.Jiance016
            this.jianchaTishiList[17].value = this.addForm.Jiance017
            this.jianchaTishiList[18].value = this.addForm.Jiance018
            this.jianchaTishiList[19].value = this.addForm.Jiance019
            this.jianchaTishiList[20].value = this.addForm.Jiance020
            this.jianchaTishiList[21].value = this.addForm.Jiance021
            this.jianchaTishiList[22].value = this.addForm.Jiance022
            this.jianchaTishiList[23].value = this.addForm.Jiance023
            this.jianchaTishiList[24].value = this.addForm.Jiance024
            this.jianchaTishiList[25].value = this.addForm.Jiance025
            this.jianchaTishiList[26].value = this.addForm.Jiance026
            this.jianchaTishiList[27].value = this.addForm.Jiance027
            this.jianchaTishiList[28].value = this.addForm.Jiance028
            this.jianchaTishiList[29].value = this.addForm.Jiance029
            this.jianchaTishiList[30].value = this.addForm.Jiance030
            this.jianchaTishiList[31].value = this.addForm.Jiance031
            this.jianchaTishiList[32].value = this.addForm.Jiance032
            this.jianchaTishiList[33].value = this.addForm.Jiance033
            this.jianchaTishiList[34].value = this.addForm.Jiance034
            this.jianchaTishiList[35].value = this.addForm.Jiance035
            this.jianchaTishiList[36].value = this.addForm.Jiance036
            this.jianchaTishiList[37].value = this.addForm.Jiance037
            this.jianchaTishiList[38].value = this.addForm.Jiance038
            this.jianchaTishiList[39].value = this.addForm.Jiance039
        },
        add() {
            this.$emit('closeJianchadan')
        },
        resetForm() {
            this.$refs.addFormRef.resetFields();
        }
    }
}
</script>

<style>
.select_class {
    display: flex;
    /* flex-wrap: wrap; */
    flex-direction: column;
    justify-content: space-around;
    /* gap: 10px; */
}

@media print {

    html,
    body {
        width: 210mm;
        height: 297mm;
    }

    .page {
        font-size: 10pt;
        width: initial;
    }

    .page .part2 td {
        height: 1cm;
    }
}

@page {
    size: landscape;
    margin: 2mm;

    /* 告诉浏览器在渲染它时不要对框进行颜色或样式调整 */
    * {
        -webkit-print-color-adjust: exact !important;
        -moz-print-color-adjust: exact !important;
        -ms-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .part2 {
        page-break-inside: avoid;
        page-break-before: always;
    }
}
#printMe {
    font-size: 18px;
}
</style>
